// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___11e4C","icon":"styles__icon___Cwv0o","content":"styles__content___mQOUH","text":"styles__text___3bo_0"};